import { getFriendlyMessage, Unauthorized } from 'scripts/application/lib/error';
import { handleCommonErrors as handleInteractively } from 'scripts/application/lib/gateway_error_interactive_handler';
import GatewayErrorSilentHandler, {
  handleCommonErrors as handleSilently,
} from 'scripts/application/lib/gateway_error_silent_handler';
import ShowToast from 'actions/toast_deprecated/show_toast';
import { ToastType } from 'models/toast_deprecated';

// glados answers 401 whenever it can't verify the session itself (supernova's
// token check failing, a missing key), not only when the agent's session has
// ended, so a 401 from it is reported and never logs the agent out. When the
// agent acted, they still see that it failed.
export default function handleTeamAssistV2Error(context, err, { isInteractive = false } = {}) {
  if (err instanceof Unauthorized) {
    new GatewayErrorSilentHandler(context).reportError(err);
    if (isInteractive) {
      context.executeAction(ShowToast, { type: ToastType.ERROR, message: getFriendlyMessage(err) });
    }
    return;
  }
  if (isInteractive) {
    handleInteractively(context, err);
  } else {
    handleSilently(context, err);
  }
}
